import { HTTPClient } from "../common/HTTPClient";

import { PaginationRequestParams } from "@/common/mixins/pagination";

export interface LineCreateRequestParams {
  shopId: number;
  shopName: string;
  lineKey: string;
  mcApiKey: string;
  mcSecretkey: string;
}

export interface LineUpdateRequestParams {
  shopName: string;
  lineKey: string;
  mcApiKey: string;
  mcSecretkey: string;
}

export interface LineScheduleTemporaryStopSyncStockRequestParams {
  shopId: number;
  fromDate: string | undefined;
  untilDate: string;
}

export class LineClient {
  constructor(private httpClient: HTTPClient) {}

  public async postLine(params: LineCreateRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shops-line",
      method: "POST",
      data: params
    });

    return data;
  }

  public async getLine(params: PaginationRequestParams): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/shops-line",
      method: "GET",
      params
    });

    return data;
  }

  public async getLineById(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-line/${id}`,
      method: "GET"
    });

    return data;
  }

  public async patchLine(
    id: number,
    params: LineUpdateRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-line/${id}`,
      method: "PATCH",
      data: params
    });

    return data;
  }

  public async deleteLine(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/shops-line/${id}`,
      method: "DELETE"
    });

    return data;
  }

  public async postLineProductSyncByShopId(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/line/shop/${id}/product/sync`,
      method: "POST"
    });

    return data;
  }

  public async postLineStockSyncByShopId(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/line/shop/${id}/stock/sync`,
      method: "POST"
    });

    return data;
  }

  public async getLineScheduleTemporaryStopSyncStock(
    params: PaginationRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/line/schedule-temporary-stop-sync-stock",
      method: "GET",
      params
    });

    return data;
  }

  public async postLineScheduleTemporaryStopSyncStock(
    params: LineScheduleTemporaryStopSyncStockRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/line/schedule-temporary-stop-sync-stock",
      method: "POST",
      data: params
    });

    return data;
  }
}
